import React from "react";
import "./NotFound.css";
import notFound from "../../images/bg-image/undraw_page_not_found_su7k.svg";
const NotFound = () => {
  return (
    <div className="grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-1 pt-24">
      <div></div>
      <div>
        <img src={notFound} alt="" />
      </div>
      <div></div>
    </div>
  );
};

export default NotFound;
